// StoreMenu.js
import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  Input
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { useLocation, useNavigate } from 'react-router-dom';

import Odometer from 'react-odometerjs';
import { Search } from "react-feather";

import BreadcrumbAboveImage from "components/Common/BreadcrumbAboveImage";
import Toast from "components/Common/Toast"; 
import useScrollRestoration from "hooks/useScrollRestoration";
import { useSelector, useDispatch } from "react-redux";
import { fetchStoreMenu } from "store/actions";

/*
import VipBadge from "../components/VipBadge";
import CardCarousel from './components/StoreMenuCardCarousel';
import RankedCarousel from './components/StoreMenuRankedCardCarousel';
import IconRow from './components/IconRow';
import { uploadImage, fetchImage } from "utils/images/imageManager";
*/

import home4 from 'assets/images/info/home4.png';
import './StoreMenu.css';
//import placeholder_image from "assets/images/info/card-placeholder-medium.png";

import axiosInstance from "utils/axiosInstance";

// NEW: shared pieces + layouts
import SearchBar from './components/shared/SearchBar';
import ResultsCount from './components/shared/ResultsCount';
import StoreMenuDesktop from './components/desktop/StoreMenuDesktop';
import StoreMenuMobile from './components/mobile/StoreMenuMobile';




/*---- Temp ----*/
/*
import bookIcon from 'assets/images/info/storeMenuIcons/book.png';
import coffeeIcon from 'assets/images/info/storeMenuIcons/coffee.png';
import consoleIcon from 'assets/images/info/storeMenuIcons/console.png';
import earphoneIcon from 'assets/images/info/storeMenuIcons/earphone.png';
import furnitureIcon from 'assets/images/info/storeMenuIcons/furniture.png';
import handshakenDrinkIcon from 'assets/images/info/storeMenuIcons/handshaken_drink.png';
import hotelIcon from 'assets/images/info/storeMenuIcons/hotel.png';
import parkIcon from 'assets/images/info/storeMenuIcons/park.png';
import petFoodIcon from 'assets/images/info/storeMenuIcons/pet_food.png';
import watchIcon from 'assets/images/info/storeMenuIcons/watch.png';

import burgerKingBanner from 'assets/images/info/storeMenuIcons/recommended/burger_king.png';
import japaneseMealBanner from 'assets/images/info/storeMenuIcons/recommended/japanese_meal.png';
import pxMartBanner from 'assets/images/info/storeMenuIcons/recommended/px_mart.png';


const cards = [
  { id: 1, title: "題組型", subtitle: "（有標準答案）", color: "#f9c74f" },
  { id: 2, title: "題組型", subtitle: "（無標準答案）", color: "#f9844a" },
  { id: 3, title: "圖文型", subtitle: "（有標準答案）", color: "#90be6d" },
  { id: 4, title: "圖文型", subtitle: "（無標準答案）", color: "#577590" },
];

const icons = [
  { id: 1, title: "精選書籍", image: bookIcon },
  { id: 2, title: "咖啡", image: coffeeIcon },
  { id: 3, title: "主機遊戲", image: consoleIcon },
  { id: 4, title: "耳機", image: earphoneIcon },
  { id: 5, title: "家具", image: furnitureIcon },
  { id: 6, title: "手搖飲", image: handshakenDrinkIcon },
  { id: 7, title: "飯店", image: hotelIcon },
  { id: 8, title: "公園綠地", image: parkIcon },
  { id: 9, title: "寵物食品", image: petFoodIcon },
  { id: 10, title: "手錶", image: watchIcon },
];

const carousel_1 = [
  {
    id: 1,
    pointsAward: '10',
    image: pxMartBanner,
    title: '全聯福利中心 中山晴光',
    rating: 4.7,
    reviewCount: 210,
    followCount: 1210,
    timeEstimate: 10,
    tags: ['很實用'],
  },
  {
    id: 2,
    pointsAward: '20',
    image: japaneseMealBanner,
    title: '狂魔炒飯x餓鬼燒肉',
    deliveryFee: '$0 外送費',
    rating: 4.5,
    reviewCount: 150,
    followCount: 1503,
    timeEstimate: 5,
    tags: ['超有趣'],
  },
  {
    id: 3,
    pointsAward: '15',
    image: burgerKingBanner,
    title: 'Burger King漢堡王 長春店',
    deliveryFee: '$0 外送費',
    rating: 4.8,
    reviewCount: 6000,
    followCount: 17508,
    timeEstimate: 8,
    tags: ['最美味'],
  },
];
*/

const StoreMenu = ({ t }) => {

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //--------------------------------------------------
  // States
  //--------------------------------------------------
  /*
  const [myInfoTopic, setMyInfoTopic] = useState([]);
  const [myInfoQuestionSets, setMyInfoQuestionSets] = useState([]);
  const [collectionThumbnailUrl, setCollectionThumbnailUrl] = useState("");
  const [topicThumbnailUrl, setTopicThumbnailUrl] = useState("");
  const [questionSetThumbnailUrls, setQuestionSetThumbnailUrls] = useState({});
  */
  //const [imageMap, setImageMap] = useState(new Map());
  //const [dataFetchError, setDataFetchError] = useState(null);
  //const [myInfoPoint, setMyInfoPoint] = useState(null);
  
  //const [activeIconIndex, setActiveIconIndex] = useState(0);

  // Search functionality
  //const [searchQuery, setSearchQuery] = useState("");
  //const [filteredMenuContent, setFilteredMenuContent] = useState([]);

  //const [storeMenu, setStoreMenu] = useState([]);
  //const [menuContent, setMenuContent] = useState([]);
  //const [menuLoading, setMenuLoading] = useState(false);


  //--------------------------------------------------
  // Load stores list on mount
  //--------------------------------------------------
  /*
  const fetchMenu = async () => {
    try {
      setMenuLoading(true);
      setDataFetchError(null);

      // Run requests in parallel
      const [menuResponse] = await Promise.all([
        axiosInstance.get(`/knovia/myInfo/storeMenu`)
      ]);

      const storeMenuResult = menuResponse.data.result;
      console.log('Store Menu Loaded:', storeMenuResult);
      setStoreMenu(storeMenuResult);

      return {
        storeMenu: storeMenuResult,
      };
    } catch (err) {
      console.error(err);
      setDataFetchError("Failed to load data.");
      return null; // <- This ensures the caller knows the fetch failed
    } finally {
      setMenuLoading(false);
    }
  };



  const fetchMenuColumns = async (storeMenu) => {
    try {
      const response = await axiosInstance.post(`/knovia/myInfo/storeMenuItems`, {
        content: storeMenu
      });

      const resolved = response.data.result;

      console.log("Resolved Menu Columns:", resolved);
      setMenuContent(resolved);

    } catch (error) {
      console.error("Error fetching menu columns:", error);
    }
  };

  const BATCH_SIZE = 5;
  
  const fetchMenuItemImages = async () => {
    let newMap = new Map(imageMap); // avoid mutation during render
    const allItems = menuContent.flatMap(section => section.content);

    const itemsToFetch = allItems.filter(item => {
      const filename = item.image;
      return filename && !newMap.has(filename);
    });

    for (let i = 0; i < itemsToFetch.length; i += BATCH_SIZE) {
      const batch = itemsToFetch.slice(i, i + BATCH_SIZE);

      const results = await Promise.all(
        batch.map(async (item) => {
          const filename = item.image;
          try {
            const url = await fetchImage(filename, "original");
            return { filename, url };
          } catch (e) {
            console.error("Failed to load image:", filename);
            return null;
          }
        })
      );

      for (const result of results) {
        if (result) newMap.set(result.filename, result.url);
      }

      // Safe batched update after each chunk
      setImageMap(new Map(newMap));
    }
  };

  useEffect(()=>{
    fetchMenuItemImages();
  },[menuContent])
  */

  const {
    storeMenu,
    menuContent,
    loading: storeMenuLoading,
    error: storeMenuError,
  } = useSelector(state => state.storeMenu);

  const {
    totalPoints,
    loading: pointsLoading,
    error: pointsError,
  } = useSelector(state => state.points);

  const imageMap = useSelector(state => state.imageMap);

  /*
  useEffect(() => {
    if (menuContent.length > 0) {
      dispatch(fetchMenuImages(menuContent));
    }
  }, [menuContent]);
  */

  useEffect(() => {
    dispatch({ type: 'FETCH_USER_POINTS' });
    dispatch({ type: 'FETCH_STORE_MENU' });
  }, [dispatch]);

  useEffect(() => {
    console.log('storeMenu:', storeMenu);
  }, [storeMenu])

  useEffect(() => {
    console.log('menuContent:', menuContent);
  }, [menuContent]);

  // Search filtering effect
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredMenuContent, setFilteredMenuContent] = useState([]);
  useEffect(() => {
    if (!menuContent || menuContent.length === 0) return;
    if (!searchQuery.trim()) {
      setFilteredMenuContent(menuContent);
      return;
    }
    const query = searchQuery.toLowerCase().trim();
    const filtered = menuContent.map(section => {
      const filteredContent = (section.content || []).filter(item => {
        // Search in title, description, and other relevant fields
        const searchableText = [
          item.title || '',
          item.label || '',
          item.description || '',
          item.name || ''
        ].join(' ').toLowerCase();
        
        return searchableText.includes(query);
      });

      return {
        ...section,
        content: filteredContent
      };
    }).filter(section => section.content.length > 0);

    setFilteredMenuContent(filtered);
  }, [searchQuery, menuContent]);

  useEffect(() => {
    /*
    const loadMenuData = async () => {
      const dataFetched = await fetchMenu();
      if (!dataFetched) return;
      const { storeMenu } = dataFetched;

      if (storeMenu) {
        fetchMenuColumns(storeMenu);
      }
    };
    */

    /*
    const fetchUserPoints = async () => {
      try {
        const { data } = await axiosInstance.get("/knovia/myInfo/infoPointAmount");
        console.log('[fetchUserPoints]', data);
        setMyInfoPoint(data);
      } catch (err) {
        console.error(err);
        pushToast(t("無法取得積分，請稍後再試"), "error");
      }
    };
    */
    //loadMenuData();
    //fetchUserPoints(); 
  }, []);


  //--------------------------------------------------
  // Info Points Row
  //--------------------------------------------------

  //const [displayedPoints, setDisplayedPoints] = useState(myInfoPoint?.totalPoints || 0);
  const [displayedPoints, setDisplayedPoints] = useState(totalPoints || 0);
  const hasMounted = useRef(false);
  
  // Sync with props if it changes from backend
  /*
  useEffect(() => {
    if(myInfoPoint?.totalPoints) {
      if (!hasMounted.current) {
        setDisplayedPoints(myInfoPoint?.totalPoints || 0);
        hasMounted.current = true;
      } else {
        // Skip animation on first load
        setDisplayedPoints(myInfoPoint?.totalPoints || 0);
      }
    }
  }, [myInfoPoint?.totalPoints]);
  */

  useEffect(() => {
    if (!hasMounted.current) {
      setDisplayedPoints(totalPoints || 0);
      hasMounted.current = true;
    } else {
      // Skip animation on first load
      setDisplayedPoints(totalPoints || 0);
    }
  }, [totalPoints]);



  /*
  const handleAddPoints = () => {
    setDisplayedPoints(prev => prev + 100); // For testing visual odometer effect
  };
  */

  // Need this comment to redeploy
  /* ---------- Toast ---------- */
  const [toasts, setToasts] = useState([]);   // { id, msg, type, dur }
  const pushToast = (msg, type = "success", duration = 3000) => {
    const id = Date.now();
    setToasts(t => [...t, { id, msg, type, duration }]);
  };
  const popToast = id => setToasts(t => t.filter(x => x.id !== id));

  const toastShownRef = useRef(false);
  useEffect(() => {
    if (pointsError && !toastShownRef.current) {
      pushToast("無法取得積分，請稍後再試", "error");
      toastShownRef.current = true;
    } else if (!pointsError) {
      toastShownRef.current = false; // reset for future errors
    }
  }, [pointsError]);


  //----------------------------------
  // Scroll-aware top bar state
  //----------------------------------

  const [showTopBar, setShowTopBar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const threshold = 20;
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (Math.abs(currentScrollY - lastScrollY) < threshold) {
        // Not enough movement to toggle
        return;
      }

      if (currentScrollY > lastScrollY) {
        // scrolling down → hide
        setShowTopBar(false);
      } else {
        // scrolling up → show
        setShowTopBar(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  //--------------------------------------------------
  // Return
  //--------------------------------------------------
  const { saveScroll } = useScrollRestoration({ offset: 0 }); // or selector: ".store-menu-list"
  // Example: when clicking a card to go to details
  const navigateToUrl = (url) => {
    saveScroll();
    navigate(url);
  };

  return (
    <React.Fragment>

      {/* Top bar */}
      <div
        style={{
          position: "fixed",
          top: 0,
          width: "100%",
          height: "60px",
          backgroundColor: "white",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          transition: "transform 0.5s ease-in-out",
          transform: showTopBar ? "translateY(0)" : "translateY(-100%)",
          zIndex: 1000,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 16px",
        }}
      >
        <div>
          <h5 style={{ margin: 0 }}>店家列表</h5>
        </div>
      </div>

      <div className="page-content store-menu-list" 
        style={{ "--page-content-background": `url(${home4})` }}
      >
        {/* toast stack */}
        {toasts.map(t => (
          <Toast
            key={t.id}
            message={t.msg}
            type={t.type}
            duration={t.duration}
            onClose={() => popToast(t.id)}
          />
        ))}

        <Container fluid className="store-menu-list-container">

          <div className="store-menu-list-breadcrumb">
            <BreadcrumbAboveImage 
              title={t("My Info")}
              breadcrumbItems={[
                { title: t("我的 AI 應用主頁"), to: "/myInfo/dashboard" },
                { title: t("探索題組"), to: "/myInfo/storeMenu" },
              ]}
            />
            </div>

            <Card className="store-menu-list-card" style={{ paddingTop: '60px' }}>
              <CardBody className="store-menu-list-card-body">

                {/*----------------------------------------*/}
                {/*------------- Small Screen -------------*/}
                {/*----------------------------------------*/}

                {/*
                <div className="d-flex justify-content-center"
                  style={{ padding: '5px', fontSize: '20px', backgroundColor: '#1e9f9f', color: 'white',
                    boxShadow: '1px 1px 4px rgba(0, 0, 0, 0.2)'
                  }}
                >
                  <p className="mb-0">TTMY</p>
                </div>
                */}

                {/* ----- MOBILE HEADER (points + search) ----- */}
                <div className="d-flex d-md-none" 
                  style={{ 
                    padding: "10px 20px 0px 20px",
                    justifyContent: "flex-end"
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', color: "#f7b900" }}>
                    <span style={{ marginRight: "1px" }}>點數：</span>
                    {hasMounted.current ? (
                      <Odometer 
                        style={{ marginTop: "0.5px", fontSize: "16px", fontWeight: "400" }}
                        value={displayedPoints}
                        format="(,ddd)"
                        duration={100}
                      />
                    ) : (
                      /* first load — plain text, no animation */
                      <span 
                        style={{ 
                          fontSize: "16px",
                          fontWeight: "400",
                          fontFamily: '"Helvetica Neue", sans-serif',
                          lineHeight: "1.1em"
                        }}
                      >
                        {displayedPoints.toLocaleString()}
                      </span>
                    )}
                  </div>
                </div>

                {/* Mobile search */}
                <div className="d-block d-md-none" style={{ padding: "10px 20px" }}>
                  <SearchBar
                    value={searchQuery}
                    onChange={setSearchQuery}
                    placeholderWhenEmpty="搜尋主題/題組"
                    placeholderWhenTyping="搜尋中..."
                    size="sm"
                  />
                  {/*
                  <div style={{ position: 'relative', width: '100%' }}>
                    <Search 
                      size={16} 
                      strokeWidth={2.5} 
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: '18px',
                        transform: 'translateY(-47%)',
                        color: searchQuery ? '#007bff' : '#495158',
                        pointerEvents: 'none',
                        transition: 'color 0.2s ease-in-out'
                      }} 
                    />
                    <Input
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{
                        paddingLeft: '42px',     // space for left icon
                        paddingRight: searchQuery ? '60px' : '20px',    // space for right text or clear button
                        backgroundColor: '#f8f8fb',
                        borderRadius: '30px',
                        minHeight: '45px',
                        resize: 'none',
                        border: '1px solid #ced4da'
                      }}
                      placeholder={searchQuery ? "搜尋中..." : "搜尋主題/題組"}
                    />
                    {searchQuery && (
                      <button
                        onClick={() => setSearchQuery("")}
                        style={{
                          position: 'absolute',
                          top: '50%',
                          right: '15px',
                          transform: 'translateY(-50%)',
                          background: 'none',
                          border: 'none',
                          color: '#999',
                          fontSize: '18px',
                          cursor: 'pointer',
                          padding: '0',
                          width: '20px',
                          height: '20px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        ×
                      </button>
                    )}
                  </div>
                  */}

                </div>




                {/*------ Big Screen ------*/}
                <div className="d-none d-md-block">
                  {/* Desktop Search Bar */}
                  <div style={{ 
                    padding: "20px 40px",
                    background: "linear-gradient(160deg, #91cdff 0%, white 50%)",
                    borderBottom: "1px solid #e9ecef"
                  }}>
                    <div style={{ position: 'relative', maxWidth: '600px', margin: '0 auto' }}>
                      <SearchBar
                        value={searchQuery}
                        onChange={setSearchQuery}
                        placeholderWhenEmpty="搜尋主題/題組"
                        placeholderWhenTyping="搜尋中..."
                        size="lg"
                      />
                      {/*
                      <Search 
                        size={20} 
                        strokeWidth={2.5} 
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: '24px',
                          transform: 'translateY(-50%)',
                          color: searchQuery ? '#007bff' : '#495158',
                          pointerEvents: 'none',
                          transition: 'color 0.2s ease-in-out'
                        }} 
                      />
                      <Input
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                          paddingLeft: '56px',     // space for left icon
                          paddingRight: searchQuery ? '80px' : '24px',    // space for right text or clear button
                          backgroundColor: '#ffffff',
                          borderRadius: '40px',
                          minHeight: '55px',
                          resize: 'none',
                          border: '2px solid #e9ecef',
                          fontSize: '16px',
                          transition: 'all 0.2s ease-in-out'
                        }}
                        placeholder={searchQuery ? "搜尋中..." : "搜尋主題/題組"}
                      />
                      {searchQuery && (
                        <button
                          onClick={() => setSearchQuery("")}
                          style={{
                            position: 'absolute',
                            top: '50%',
                            right: '20px',
                            transform: 'translateY(-50%)',
                            background: 'none',
                            border: 'none',
                            color: '#999',
                            fontSize: '20px',
                            cursor: 'pointer',
                            padding: '0',
                            width: '24px',
                            height: '24px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'color 0.2s ease-in-out'
                          }}
                          onMouseEnter={(e) => e.target.style.color = '#666'}
                          onMouseLeave={(e) => e.target.style.color = '#999'}
                        >
                          ×
                        </button>
                      )}
                      */}
                    </div>

                    {searchQuery && (
                      <ResultsCount
                        count={filteredMenuContent.reduce((sum, s) => sum + (s.content?.length || 0), 0)}
                        wrapperStyle={{ paddingTop: 20 }}
                        desktop
                      />
                    )}
                  </div>

                  {/* Desktop Search Results Count */}
                  {/*
                  {searchQuery && (
                    <div style={{ 
                      padding: "20px 40px",
                      background: "#f8f9fa",
                      borderBottom: "1px solid #e9ecef"
                    }}>
                      <p style={{ 
                        margin: "0", 
                        fontSize: "16px", 
                        color: "#666",
                        textAlign: "center",
                        fontWeight: "500"
                      }}>
                        找到 {filteredMenuContent.reduce((total, section) => total + (section.content?.length || 0), 0)} 個結果
                      </p>
                    </div>
                  )}
                  */}

                  {/* Desktop Category Icons */}
                  {/*
                  <div style={{ 
                    padding: "30px 40px 20px 40px",
                    background: "#ffffff"
                  }}>
                    <div style={{ 
                      display: "grid", 
                      gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
                      gap: "20px",
                      maxWidth: "1200px",
                      margin: "0 auto"
                    }}>
                      {icons.map((icon, index) => (
                        <div
                          key={icon.id}
                          onClick={() => setActiveIconIndex(index)}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '20px 15px',
                            borderRadius: '12px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out',
                            border: activeIconIndex === index ? '2px solid #007bff' : '2px solid transparent',
                            backgroundColor: activeIconIndex === index ? '#f0f8ff' : '#f8f9fa',
                            transform: activeIconIndex === index ? 'scale(1.05)' : 'scale(1)'
                          }}
                          onMouseEnter={(e) => {
                            if (activeIconIndex !== index) {
                              e.target.style.backgroundColor = '#f0f0f0';
                              e.target.style.transform = 'scale(1.02)';
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (activeIconIndex !== index) {
                              e.target.style.backgroundColor = '#f8f9fa';
                              e.target.style.transform = 'scale(1)';
                            }
                          }}
                        >
                          <img 
                            src={icon.image} 
                            alt={icon.title}
                            style={{
                              width: '48px',
                              height: '48px',
                              marginBottom: '12px',
                              filter: activeIconIndex === index ? 'brightness(1.1)' : 'brightness(1)',
                              transition: 'filter 0.2s ease-in-out'
                            }}
                          />
                          <span style={{
                            fontSize: '14px',
                            fontWeight: activeIconIndex === index ? '600' : '500',
                            color: activeIconIndex === index ? '#007bff' : '#495057',
                            textAlign: 'center',
                            lineHeight: '1.2'
                          }}>
                            {icon.title}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                  */}
                  {/* Desktop Content Sections */}
                  {/*
                  {(searchQuery ? filteredMenuContent : storeMenu).map((column, index) => {
                    const resolved = (searchQuery ? filteredMenuContent : menuContent).find(c => c.label === column.label);

                    return (
                      <div key={index} style={{ 
                        padding: "0 40px 40px 40px",
                        background: "#ffffff"
                      }}>
                        <div style={{ 
                          borderTop: "1px solid #e9ecef",
                          paddingTop: "30px"
                        }}/>
                        
                        <div style={{ 
                          maxWidth: "1200px", 
                          margin: "0 auto",
                          padding: "0 20px"
                        }}>
                          <div style={{ 
                            marginBottom: "25px",
                            textAlign: "center"
                          }}>
                            <h3 style={{ 
                              margin: "0 0 8px 0", 
                              fontSize: "24px",
                              fontWeight: "600",
                              color: "#2c3e50"
                            }}>
                              {column.label}
                            </h3>
                            {column.description && (
                              <p style={{ 
                                margin: "0", 
                                fontSize: "16px",
                                color: "#6c757d",
                                maxWidth: "600px",
                                margin: "0 auto"
                              }}>
                                {column.description}
                              </p>
                            )}
                          </div>

                          {(resolved?.content && ["topics", "questionSets"].includes(column.type)) && (
                            <div style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                              gap: "24px"
                            }}>
                              {resolved.content.map((item, itemIndex) => (
                                <div
                                  key={itemIndex}
                                  style={{
                                    background: "#ffffff",
                                    borderRadius: "16px",
                                    padding: "20px",
                                    border: "1px solid #e9ecef",
                                    transition: "all 0.2s ease-in-out",
                                    cursor: "pointer"
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.transform = "translateY(-4px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.transform = "translateY(0)";
                                  }}
                                >
                                  {item.image && (
                                    <div style={{
                                      width: "100%",
                                      height: "160px",
                                      borderRadius: "12px",
                                      marginBottom: "16px",
                                      backgroundImage: `url(${imageMap[item.image] || placeholder_image})`,
                                      backgroundSize: "cover",
                                      backgroundPosition: "center",
                                      backgroundRepeat: "no-repeat"
                                    }} />
                                  )}
                                  <h4 style={{
                                    margin: "0 0 8px 0",
                                    fontSize: "18px",
                                    fontWeight: "600",
                                    color: "#2c3e50",
                                    lineHeight: "1.3"
                                  }}>
                                    {item.title || item.label || item.name}
                                  </h4>
                                  {item.description && (
                                    <p style={{
                                      margin: "0",
                                      fontSize: "14px",
                                      color: "#6c757d",
                                      lineHeight: "1.5",
                                      display: "-webkit-box",
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden"
                                    }}>
                                      {item.description}
                                    </p>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}

                          {(resolved?.content && ["ranking", "qsRanking"].includes(column.type)) && (
                            <div style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                              gap: "24px"
                            }}>
                              {resolved.content.map((item, itemIndex) => (
                                <div
                                  key={itemIndex}
                                  style={{
                                    background: "#ffffff",
                                    borderRadius: "16px",
                                    padding: "24px",
                                    border: "1px solid #e9ecef",
                                    transition: "all 0.2s ease-in-out",
                                    cursor: "pointer"
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.transform = "translateY(-4px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.transform = "translateY(0)";
                                  }}
                                >
                                  <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "16px"
                                  }}>
                                    <div style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "50%",
                                      background: itemIndex < 3 ? "#ffd700" : "#e9ecef",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginRight: "16px",
                                      fontSize: "18px",
                                      fontWeight: "bold",
                                      color: itemIndex < 3 ? "#fff" : "#6c757d"
                                    }}>
                                      {itemIndex + 1}
                                    </div>
                                    {item.image && (
                                      <div style={{
                                        width: "60px",
                                        height: "60px",
                                        borderRadius: "8px",
                                        backgroundImage: `url(${imageMap[item.image] || placeholder_image})`,
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        backgroundRepeat: "no-repeat"
                                      }} />
                                    )}
                                  </div>
                                  <h4 style={{
                                    margin: "0 0 8px 0",
                                    fontSize: "18px",
                                    fontWeight: "600",
                                    color: "#2c3e50",
                                    lineHeight: "1.3"
                                  }}>
                                    {item.title || item.label || item.name}
                                  </h4>
                                  {item.description && (
                                    <p style={{
                                      margin: "0",
                                      fontSize: "14px",
                                      color: "#6c757d",
                                      lineHeight: "1.5"
                                    }}>
                                      {item.description}
                                    </p>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                  */}

                  {/* Desktop No Results Message */}
                  {/*
                  {searchQuery && filteredMenuContent.length === 0 && (
                    <div style={{ 
                      padding: "80px 40px", 
                      textAlign: "center",
                      color: "#666",
                      background: "#ffffff"
                    }}>
                      <Search size={64} style={{ marginBottom: "24px", opacity: 0.5 }} />
                      <h3 style={{ margin: "0 0 16px 0", fontSize: "24px", color: "#495057" }}>
                        沒有找到與 "{searchQuery}" 相關的結果
                      </h3>
                      <p style={{ margin: "0", fontSize: "16px", opacity: 0.7 }}>
                        請嘗試其他關鍵字或清除搜尋
                      </p>
                    </div>
                  )}
                  */}
                </div>

                <div className="section-div" />

                {/*------ Small Screen ------*/}
                <div className="d-block d-md-none">

                  {/* Search Results Count */}
                  {/*
                  {searchQuery && (
                    <div style={{ 
                      padding: "0 20px 10px 20px",
                      borderBottom: "1px solid #eee"
                    }}>
                      <p style={{ 
                        margin: "0", 
                        fontSize: "14px", 
                        color: "#666",
                        textAlign: "center"
                      }}>
                        找到 {filteredMenuContent.reduce((total, section) => total + (section.content?.length || 0), 0)} 個結果
                      </p>
                    </div>
                  )}
                  */}

                  {/*
                  <IconRow
                    icons={icons}
                    activeIconIndex={activeIconIndex}
                    setActiveIconIndex={setActiveIconIndex}
                  />
                  */}

                  {/* Types: ['topics', 'ranking', 'questionSets', 'qsRanking'] */}
                  {/*
                  {(searchQuery ? filteredMenuContent : storeMenu).map((column, index) => {
                    const resolved = (searchQuery ? filteredMenuContent : menuContent).find(c => c.label === column.label);

                    return (
                      <div key={index}>
                        <div className="store-menu-section-div" style={{ margin: "0px 0px 0px 0px" }}/>
                        <Row>
                          <Col className="store-menu-topic-filled-carousel-col">
                            <div style={{ paddingLeft: "20px" }}>
                              <p className="mb-0 store-menu-section-title">{column.label}</p>
                              {column.description && 
                                <p className="mb-0 store-menu-section-subtitle">{column.description}</p>
                              }
                            </div>
                            {(resolved?.content && ["topics", "questionSets"].includes(column.type)) &&
                              <CardCarousel 
                                cards={resolved.content}
                                type={column.type}
                                imageMap={imageMap}
                                navigateToUrl={navigateToUrl}
                              />
                            }
                            {(resolved?.content && ["ranking", "qsRanking"].includes(column.type)) &&
                              <RankedCarousel 
                                cards={resolved.content}
                                type={column.type}
                                imageMap={imageMap}
                                navigateToUrl={navigateToUrl}
                              />
                            }
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
                  */}

                  {/* No Results Message */}
                  {/*
                  {searchQuery && filteredMenuContent.length === 0 && (
                    <div style={{ 
                      padding: "40px 20px", 
                      textAlign: "center",
                      color: "#666"
                    }}>
                      <Search size={48} style={{ marginBottom: "16px", opacity: 0.5 }} />
                      <p style={{ margin: "0", fontSize: "16px" }}>
                        沒有找到與 "{searchQuery}" 相關的結果
                      </p>
                      <p style={{ margin: "8px 0 0 0", fontSize: "14px", opacity: 0.7 }}>
                        請嘗試其他關鍵字或清除搜尋
                      </p>
                    </div>
                  )}
                  */}

                </div>

                {/* ------- DESKTOP ------- */}
                <div className="d-none d-md-block">
                  <StoreMenuDesktop
                    storeMenu={searchQuery ? storeMenu : storeMenu}
                    menuContent={menuContent}
                    filteredMenuContent={filteredMenuContent}
                    searchQuery={searchQuery}
                    imageMap={imageMap}
                    navigateToUrl={navigateToUrl}
                  />
                </div>

                {/* ------- MOBILE ------- */}
                <div className="d-block d-md-none">
                  {searchQuery && (
                    <ResultsCount
                      count={filteredMenuContent.reduce((sum, s) => sum + (s.content?.length || 0), 0)}
                    />
                  )}
                  <StoreMenuMobile
                    storeMenu={storeMenu}
                    menuContent={menuContent}
                    filteredMenuContent={filteredMenuContent}
                    searchQuery={searchQuery}
                    imageMap={imageMap}
                    navigateToUrl={navigateToUrl}
                  />
                </div>


              </CardBody>
            </Card>

        </Container>
      </div>

    </React.Fragment>
  );
};

export default withTranslation()(StoreMenu);


